import React, { useEffect, useState } from "react";
import axios from "axios";
import { Reveal } from "../components/Reveal";
import { useLang } from "../i18n/LangProvider";
import { getLegal } from "../i18n/legalTranslations";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Tarifario = () => {
  const { lang } = useLang();
  const t = getLegal(lang).tariff;
  const [p, setP] = useState(null);

  useEffect(() => { axios.get(`${API}/pricing`).then((r) => setP(r.data)); }, []);

  if (!p) return <div className="pt-32 px-6 min-h-[60vh]" />;

  return (
    <div className="pt-32 pb-24 px-6">
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <p className="text-xs tracking-widest2 uppercase text-brand-silver mb-4">{t.eyebrow}</p>
          <h1 className="text-4xl lg:text-5xl font-light text-brand-platinum">{t.title}</h1>
          <p className="mt-4 text-xs text-brand-dim">{t.subtitle}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-14">
          <Block title={t.block_transfer}>
            <Row k={t.row_base} v={`CHF ${p.base_fare_chf.toFixed(2)}`} />
            <Row k={t.row_km_short} v={`CHF ${p.rate_per_km.toFixed(2)}`} />
            <Row k={t.row_km_long} v={`CHF ${p.degression_rate_per_km.toFixed(2)}`} />
            <Row k={t.row_child_seat} v={`CHF ${p.child_seat_chf.toFixed(2)}`} />
            <Row k={t.row_pet_no} v={`CHF ${p.pet_no_carrier_chf.toFixed(2)}`} />
            <Row k={t.row_pet_yes} v={`CHF ${p.pet_with_carrier_chf.toFixed(2)}`} />
          </Block>

          <Block title={t.block_fullday}>
            <Row k={t.row_full_base} v={`CHF ${p.full_day_base_chf.toFixed(0)}`} />
            <Row k={t.row_full_extra} v={`CHF ${p.full_day_extra_hour_chf.toFixed(0)}`} />
            <Row k={t.row_full_region} v={t.row_region_val} />
          </Block>

          <Block title={t.block_courier}>
            <Row k={t.row_courier_base} v={`CHF ${p.courier_base_chf.toFixed(2)}`} />
            <Row k={t.row_courier_km} v={`CHF ${p.courier_rate_per_km.toFixed(2)}`} />
            <Row k={t.row_courier_night} v={`+${(p.courier_night_supplement_pct * 100).toFixed(0)}%`} />
            <Row k={t.row_courier_weekend} v={`+${(p.courier_weekend_supplement_pct * 100).toFixed(0)}%`} />
          </Block>

          <Block title={t.block_hours}>
            <Row k={t.row_normal} v="—" />
            <Row k={t.row_intermediate} v={`+${(p.intermediate_supplement_pct * 100).toFixed(0)}%`} />
            <Row k={t.row_night} v={`+${(p.night_supplement_pct * 100).toFixed(0)}%`} />
            <Row k={t.row_weekend} v={`+${(p.weekend_supplement_pct * 100).toFixed(0)}%`} />
          </Block>
        </div>

        <p className="mt-12 text-xs text-brand-dim leading-relaxed">
          {t.footer_note} {t.footer_see} <a href="/termos-e-condicoes" className="underline hover:text-brand-platinum">{t.footer_terms}</a> {t.footer_for}
        </p>
      </div>
    </div>
  );
};

const Block = ({ title, children }) => (
  <div className="border border-brand-border p-6">
    <p className="text-xs tracking-widest2 uppercase text-brand-silver mb-6">{title}</p>
    <div className="space-y-3">{children}</div>
  </div>
);
const Row = ({ k, v }) => (
  <div className="flex items-baseline justify-between border-b border-brand-border pb-2">
    <span className="text-xs text-brand-silver">{k}</span>
    <span className="text-brand-platinum">{v}</span>
  </div>
);

export default Tarifario;
